import {
  IApiIndividualResponse,
  IPaginationParams,
  PaginatedQueryResponse,
} from '@/types/api'
import {
  AllPaymentMethodConfigurations,
  ICheckoutPayload,
  IFixPayCheckoutPayload,
  INewCheckoutPayload,
  IPayment,
} from '@/types/payment'
import qs from 'qs'
import { ApiService } from './ApiService'

export interface IPaymentGetFilters {
  courseId?: string
  userId?: string
}

export type ICategoryGetParams = {
  filters?: IPaymentGetFilters
  pagination?: IPaginationParams
}

export type GetPaymentOptionsOpts = {
  courseId: string
  cohortId: string
  country?: string
}

export class PaymentService extends ApiService {
  static GET_PATH = `/payments`
  static POST_PATH = `/payments/checkout`
  static POST_FIXPAY_PATH = `/payments/fixpay-checkout-session`
  static GET_PAYMENT_OPTIONS_PATH = `/payments/options`
  static POST_CHECKOUT_PATH = `/payments/checkout`

  static async getPayments(
    filters: IPaymentGetFilters = {},
    pagination: IPaginationParams = {}
  ): Promise<PaginatedQueryResponse<IPayment>> {
    const queryString = qs.stringify({ ...filters, ...pagination })

    return ApiService.get(`${PaymentService.GET_PATH}?${queryString}`)
  }

  static async postCheckout(body: ICheckoutPayload) {
    return ApiService.post(PaymentService.POST_PATH, body)
  }

  static async postFixPayCheckout(body: IFixPayCheckoutPayload) {
    return ApiService.post(PaymentService.POST_FIXPAY_PATH, body)
  }

  static async getPaymentOptions({
    courseId,
    cohortId,
    country,
  }: GetPaymentOptionsOpts): Promise<
    IApiIndividualResponse<AllPaymentMethodConfigurations[]>
  > {
    const queryString = qs.stringify({ courseId, cohortId, country })

    return ApiService.get(
      `${PaymentService.GET_PAYMENT_OPTIONS_PATH}?${queryString}`
    )
  }

  static async checkout(body: INewCheckoutPayload) {
    return ApiService.post(PaymentService.POST_CHECKOUT_PATH, body)
  }
}
